import React from 'react';
import { Box, LinearProgress, Tooltip, Typography } from '@mui/material';
import { FormattedMessage, useIntl } from 'react-intl';

interface Props {
  done: number | null;
  total: number | null;
}

function phaseId(done: number, total: number): string {
  if (total === 0) return 'checklistPhaseEmpty';
  if (done >= total) return 'checklistPhaseComplete';
  if (done <= 5) return 'checklistPhasePreparation';
  if (done <= 11) return 'checklistPhaseOnSite';
  return 'checklistPhaseHandover';
}

function SetupProgress({ done, total }: Props) {
  const intl = useIntl();

  if (done === null || total === null || total === 0) {
    return (
      <Typography variant="body2" color="text.secondary" sx={{ fontSize: 'small' }}>
        --
      </Typography>
    );
  }

  const percent = Math.round((done / total) * 100);
  const color = percent >= 100 ? 'success' : percent > 0 ? 'warning' : 'inherit';

  const tooltip = intl.formatMessage({
    id: phaseId(done, total),
    defaultMessage: 'Progress'
  });

  return (
    <Tooltip title={tooltip}>
      <Box
        display="flex"
        alignItems="center"
        sx={{ minWidth: { xs: 'auto', md: 120 } }}
      >
        <Box sx={{ width: 70, mr: 1 }}>
          <LinearProgress
            variant="determinate"
            value={percent}
            color={color === 'inherit' ? 'primary' : (color as any)}
            sx={{ height: 6, borderRadius: 3 }}
          />
        </Box>
        <Typography variant="body2" sx={{ fontSize: 'small', whiteSpace: 'nowrap' }}>
          {done}/{total}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default SetupProgress;
